import { initApnListeners } from '@finn-no/displayads-client';
import lazyLoad from '../../util/lazyLoad.js';
import BannerTakeover from './bannerTakeover.js';
let clearAd = true;
export default class AppNexus {
    constructor(params) {
        this.apntag = params.apntag || {};
        this.apntag.anq = this.apntag.anq || [];
        this.server = params.server;
        this._window = params._window;
        this.member = params.member;
        this.isEqual = params.isEqual || (() => false);
        this.loaded = {};
        this.refreshRequested = false;
    }

    clearWallpaper() {
        let body;
        if (window === window.top) {
            body = document.body;
        } else {
            body = window.parent.document.body;
        }
        body.style.cssText = '';
    }

    collapseTopboard() {
        const topboard = document.querySelector('#topboard');
        if (topboard) {
            topboard.style.height = null;
        }
    }

    clearSkyscraperleft() {
        const skyscraper = document.querySelector('#skyscraperleft_1');
        if (skyscraper) {
            skyscraper.innerHTML = '';
        }
    }

    showBoards(elements) {
        if (elements && !this.refreshRequested) {
            lazyLoad(elements, this._showOrRefreshBoards.bind(this));
            this.refreshRequested = true;
        }
    }

    showBanners(elements = [], data = {}) {
        if (elements) {
            const horseShoe = [];
            let wallpaper;
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].getAttribute('data-astbanner-name') === 'wallpaper') {
                    wallpaper = elements[i];
                } else {
                    horseShoe.push(elements[i]);
                }
            }

            if (this.isEqual(this.data, data) && this.config) {
                lazyLoad(horseShoe, this._refreshBanners.bind(this));
                if (wallpaper) {
                    this._refreshBanners(wallpaper);
                }
            } else {
                if (this.apntag.clearRequest) {
                    this.apntag.clearRequest();
                }
                this._getConfig(data, this._loadBanners.bind(this));
                lazyLoad(horseShoe, this._showBanners.bind(this));

                if (wallpaper) {
                    this._showBanners(wallpaper);
                }
            }
        }
    }

    data() {
        return this.data;
    }

    _loadBanners(config) {
        let appNexusConfig = JSON.parse(JSON.stringify(config));
        appNexusConfig = this._addKeywordForABTest(appNexusConfig);

        this.apntag.anq.push(() => {
            this.apntag.onEvent('adLoaded', data => {
                this.apntag.fireImpressionTrackers(data);
                this.handleBlocketAds(data);
            });
        });

        clearAd = true;

        if (Object.keys(appNexusConfig).length > 0) {
            this.apntag.anq.push(() => {
                if (this.member) {
                    appNexusConfig.pageOpts.member = this.member;
                }
                this.apntag.setPageOpts(appNexusConfig.pageOpts);
                for (const tag in appNexusConfig.tags) {
                    if (Object.prototype.hasOwnProperty.call(appNexusConfig.tags, tag)) {
                        this.apntag.defineTag(appNexusConfig.tags[tag]);

                        if (tag === 'wallpaper') {
                            this.apntag.onEvent('adNoBid', 'wallpaper', this.clearWallpaper);
                        }
                        if (tag === 'topboard') {
                            this.apntag.onEvent('adNoBid', 'topboard', this.collapseTopboard);
                        }
                        if (tag === 'skyscraperleft_1') {
                            this.apntag.onEvent('adNoBid', 'skyscraperleft_1', this.clearSkyscraperleft);
                        }
                        this._handleNativeFormat(tag);
                    }
                }
                this._addHorseShoeHandler();
                this.apntag.loadTags();
                initApnListeners(this.apntag, appNexusConfig);
            });
        }
    }

    handleBlocketAds(adObj) {
        const tagName = adObj.targetId;

        if (tagName === 'index_panorama' && this._window.FINN.travel.device !== 'mobile') {
            const target = document.getElementById(tagName);
            if (!target) return;

            // note that creative likely always will exist if adLoaded is fired
            const creative = target.getElementsByTagName('IFRAME')[0];
            if (!creative) return;

            if (creative.clientHeight === 900) {
                target.classList.remove('panorama');
                target.classList.add('takeover');

                // pageholder will always be the root of troika pages
                const root = document.getElementsByClassName('pageholder')[0];
                root.style.position = 'relative';
                root.style.marginTop = '240px';
            } else {
                target.classList.add('panorama');
                target.classList.remove('takeover');

                const root = document.getElementsByClassName('pageholder')[0];
                root.style.position = '';
                root.style.marginTop = '';
            }
        }
    }

    _addHorseShoeHandler() {
        this.apntag.onEvent('adAvailable', adObj => {
            const tagName = adObj.targetId;

            if (!this._isFrontpage()) {
                document.getElementById(
                    tagName
                ).innerHTML = `<div id="${tagName}-button" class="banners-cogwheel-button" style="position: relative;" />`;
            }

            if (tagName === 'skyscraperleft_1') {
                const horseshoeContainer = document.getElementsByClassName('banners');
                const horseshoeContainer2 = document.getElementsByClassName('container');

                if (horseshoeContainer.length > 0) {
                    horseshoeContainer[0].classList.add('banners-is-horse-shoe');
                } else if (horseshoeContainer2.length > 0) {
                    horseshoeContainer2[0].classList.add('banners-is-horse-shoe');
                }
            }
        });
    }

    _addKeywordForABTest(appNexusConfig) {
        if (FINN.travel.abTestKey) {
            appNexusConfig.pageOpts.keywords['no-sno-finn-travel_framework'] = FINN.travel.abTestKey;
        }
        return appNexusConfig;
    }

    _handleNativeFormat(tag) {
        window.apntag.onEvent('adLoaded', tag, adObj => {
            let adToRender = '';
            if (this._isTakeover(tag, adObj)) {
                const bannerAd = new BannerTakeover(tag, adObj, null);
                bannerAd.render();
            } else if (adObj.adType === 'native') {
                adObj.tagName = tag;
                if (this._isSsaNative(adObj)) {
                    adToRender = this._getSsaNativeTemplate(adObj);
                } else {
                    adToRender = this._getNativeTemplate(adObj);
                }
                let ele = document.getElementById(tag);
                if (ele) {
                    ele.innerHTML = adToRender;
                    this._applyNativeLayout(ele);
                } else if (window.FINN && window.FINN.banner && window.FINN.banner.hub) {
                    window.FINN.banner.hub.subscribe('banner-container-ready', readyTag => {
                        if (tag === readyTag) {
                            ele = document.getElementById(tag);
                            ele.innerHTML = adToRender;
                            this._applyNativeLayout(ele);
                        }
                    });
                }
            }
        });

        // FIX: eager load board on frontpage
        if (this._isFrontpage()) {
            window.apntag.onEvent('adAvailable', tag, () => {
                this._eagerLoadTagWhenReady(tag, 4, 500);
            });
        }
    }

    _eagerLoadTagWhenReady(tag, attempts, interval) {
        if (document.getElementById(tag)) {
            if (this._window.FINN.travel.whitelabel === 'blocket' && document.getElementById(tag).innerHTML !== '' && clearAd) {
                clearAd = false;
                document.getElementById(tag).innerHTML = '';
            }
            this.apntag.anq.push(() => {
                this.apntag.showTag(tag);
            });
        } else {
            setTimeout(() => {
                this._eagerLoadTagWhenReady(tag, --attempts, interval);
            }, interval);
        }
    }

    _isFrontpage() {
        return (
            window.location.pathname === '/reise/' ||
            window.location.pathname === '/reise/fly' ||
            window.location.pathname === '/reise/fly/' ||
            window.location.pathname === '/reise/hotell' ||
            window.location.pathname === '/reise/hotell/' ||
            window.location.pathname === '/reise/leiebil' ||
            window.location.pathname === '/reise/leiebil/' ||
            window.location.pathname === '/reise/pakker' ||
            window.location.pathname === '/reise/pakker/'
        );
    }

    _isTakeover(tagName, adObj) {
        return tagName === 'board_2' && adObj.height && adObj.width && adObj.height === 3 && adObj.width === 3;
    }

    _isSsaNative(adObj) {
        if (adObj.native.desc2) {
            return adObj.native.desc2 === 'content';
        }

        if (adObj.native.custom) {
            const isSSAObject = adObj.native.custom.meta_data != null;
            const ssaType = adObj.native.custom.type;
            return isSSAObject && ssaType === 'content';
        }

        return false;
    }

    _applyNativeLayout(ele) {
        const ITEM_CLASS_NAME = 'resultbanner';
        const resultItem = ele.parentNode;
        resultItem.style.cssText = 'width:100%;';
        resultItem.classList.remove(ITEM_CLASS_NAME);
        // resultItem.classList.add('align-items-stretch');
    }

    _getNativeTemplate(adObj) {
        let iconImage = '';
        const adData = adObj.native;

        if (adData.icon && adData.icon.url) {
            iconImage =
                '<div class="overflowify">' +
                '<div class="fright result-item-logo-container mls mts" style="height: 60px;">' +
                `<img class="result-item-logo" src="${adData.icon.url}" alt="${adData.sponsoredBy}" />` +
                '</div>' +
                '</div>';
        }

        return (
            `<!-- NativeNetboard - Creative Id ${adObj.creativeId} -->` +
            `<div id="${adObj.tagName}-button" class="ads-transparency-netboard" style="top:0"></div>` +
            `<a class="nativeanchor" href="${adData.clickTrackers[0]}./clickenc=${adData.clickUrl}" ` +
            'class="mod flex align-items-stretch man clickable userhistory linkblock licorice unoverflowify" target="_blank">' +
            '<div class="inner r-pal">' +
            '<div class="bd">' +
            '<div class="result-item-image">' +
            '<div class="format3by2">' +
            `<img src="${adData.image.url}" class="centered-image" alt="${adData.sponsoredBy}">` +
            '</div>' +
            '</div>' +
            '<div class="unoverflowify">' +
            '<div class="d1 mll">' +
            '<span class="result-status mrs mtm bg-banana objectstatus valign-middle centerify" style="white-space: normal;width:100%;">' +
            `Annonse fra ${adData.sponsoredBy}</span>` +
            '</div>' +
            `<h3 class="t3 word-break mhn mvs mll result-item-heading leftify" id="native-add__title">${adData.title}</h3>` +
            `${iconImage}` +
            '</div>' +
            '</div>' +
            '</div>' +
            '</a>'
        );
    }

    _getSsaNativeTemplate(adObj) {
        const adData = this._getSsaAData(adObj);

        return (
            `<!-- SSAContent - Creative Id ${adObj.creativeId} -->` +
            '<div class="ssa-content-ad">' +
            `<div id="${adObj.tagName}-button" class="ads-transparency-ssa"></div>` +
            `<a href="${adData.click.tracker}./clickenc=${adData.click.url}"` +
            'class="linkblock link--block dark-links" target="_blank" rel="noopener">' +
            '<div class="ssa-flex ssa-flex--column" style="height: 100%;">' +
            '<div class="ssa-flex ssa-content-ad__annonse" style="flex: 1;">ANNONSE</div>' +
            '<div class="ssa-flex ssa-flex--justify-space-between align-items-center ssa-content-ad__titlegroup">' +
            `<h3 class="man u-ma0 licorice u-licorice ssa-content-ad__heading">${adData.title}</h3>` +
            `<img class="blockify u-blockify ssa-content-ad__logo" width="70" height="70" src="${adData.logo.url}" alt="">` +
            '</div>' +
            '<div class="flex ssa-content-ad__body">' +
            '<div class="ssa-content-ad__image_container" style="flex: none;">' +
            `<img class="blockify u-blockify ssa-content-ad__image" width="330" height="330" src="${adData.image.url}" alt="">` +
            '</div>' +
            '<div class="ssa-flex ssa-flex--column ssa-flex--justify-space-between ssa-content-ad__box">' +
            `<p class="man u-ma0 licorice u-licorice ssa-content-ad__description">${adData.text}</p>` +
            `<p class="man u-ma0"><button class="primary button button--cta ssa-content-ad__cta">${adData.click.label}</button></p>` +
            '</div>' +
            '</div>' +
            '</div>' +
            '</a>' +
            '</div>'
        );
    }

    _formatUrl(url) {
        return url.replace(/(^\w+:|^)\/\//, '').replace(/\/.*$/, '');
    }

    _escape(text) {
        let newtext = text;
        if (typeof text === 'string') {
            newtext = text
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }
        return newtext;
    }

    _getSsaAData(adObj) {
        const ad = adObj.native;
        const data = {};
        data.logo = {};
        data.image = {};
        data.impression = {};
        data.click = {};
        data.click.url = this._escape(ad.clickUrl);
        data.click.tracker = ad.clickTrackers.length ? this._escape(ad.clickTrackers[0]) : '';
        data.impression.tracker = ad.impressionTrackers ? this._escape(ad.impressionTrackers[0]) : '';

        data.price = '';
        if (ad.price) {
            data.price = ad.price; // v3
        } else if (ad.custom && ad.custom.price) {
            data.price = ad.custom.price; // v2
        }
        data.price = this._escape(data.price);

        if (ad.cta) {
            data.click.label = ad.cta; // v3
        } else if (ad.custom && ad.custom.destination_label) {
            data.click.label = ad.custom.destination_label; // v2
        } else {
            data.click.label = this._formatUrl(ad.clickUrl);
        }
        data.click.label = this._escape(data.click.label);

        if (ad.image && ad.image.url) {
            // v3
            data.image.url = this._escape(ad.image.url);
            data.image.height = this._escape(ad.image.height);
            data.image.width = this._escape(ad.image.width);
        } else if (ad.mainMedia && Array.isArray(ad.mainMedia) && ad.mainMedia.length > 0 && ad.mainMedia[0].url) {
            // v2
            data.image.url = this._escape(ad.mainMedia[0].url);
            data.image.height = this._escape(ad.mainMedia[0].height);
            data.image.width = this._escape(ad.mainMedia[0].width);
        } else {
            data.image.url = '';
            data.image.height = 0;
            data.image.width = 0;
        }

        if (ad.icon && ad.icon.url) {
            data.logo.url = ad.icon.url; // v3
        } else if (ad.iconImgUrl) {
            data.logo.url = ad.iconImgUrl; // v2
        } else {
            data.logo.url = '';
        }
        data.logo.url = this._escape(data.logo.url);

        if (ad.body) {
            data.text = ad.body; // v3
        } else if (ad.fullText) {
            data.text = ad.fullText; // v2
        } else if (ad.description) {
            data.text = ad.description; // v2
        } else {
            data.text = '';
        }
        data.text = this._escape(data.text);

        data.title = ad.title ? this._escape(ad.title) : '';

        return data;
    }

    _refreshBanners(element) {
        const tagIds = [];
        tagIds.push(element.id);
        this.apntag.anq.push(() => {
            this.apntag.refresh(tagIds);
        });
    }

    _showBanners(element) {
        const tagId = element.id;
        this.apntag.anq.push(() => {
            this.apntag.showTag(tagId);
        });
    }

    _showOrRefreshBoards(element) {
        const tagId = element.id;
        if (this.loaded[tagId] && this.loaded[tagId].config === this.config) {
            this.apntag.anq.push(() => {
                this.apntag.refresh(tagId);
            });
        } else {
            this.loaded[tagId] = { config: this.config };
            this.apntag.anq.push(() => {
                this.apntag.showTag(tagId);
            });
        }
        this.refreshRequested = false;
    }

    _getConfig(data, callback) {
        this.data = data;
        this.data.whitelabel = this._window.FINN.travel.whitelabel;
        const vertical = this._window.FINN.travel.banner.vertical;
        const appNexusPage = this._window.FINN.travel.banner.appNexusPage;
        const device = this._window.FINN.travel.banner.device || this._window.FINN.travel.device;

        this.server.loadJsonCors(`/${vertical}/${appNexusPage}/${device}`, data, (error, appNexusConfig) => {
            if (!error) {
                if (this._window.FINN.travel.whitelabel === 'blocket') {
                    appNexusConfig.pageOpts.keywords['se-generic-viewportheight'] =
                        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                    appNexusConfig.pageOpts.keywords['se-generic-viewportwidth'] =
                        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    appNexusConfig.pageOpts.keywords['se-generic-screenheight'] = window.outerHeight;
                    appNexusConfig.pageOpts.keywords['se-generic-screenwidth'] = window.outerWidth;
                    const currentURL = new URL(window.location.href);
                    if (currentURL.searchParams.get('cabinType') !== null) {
                        appNexusConfig.pageOpts.keywords['se-blocket-tickettype'] = currentURL.searchParams.get('cabinType');
                        appNexusConfig.pageOpts.keywords['se-blocket-airport'] = currentURL.searchParams
                            .get('requestedDestination')
                            .split('.')[0];
                    }
                }
                this.config = appNexusConfig;
                callback(appNexusConfig);
            }
        });
    }
}
